/* PROPOSAL: we seem to have a lot of small helper modules, what are people's
 * thoughts on combining them into a single `helpers/index.js` until more clear
 * module boundaries suggest themselves? delete this comment if rejected
 */

// this probably doesn't need all these checks, but I couldn't find support data explicitly
// guaranteeing that these have cross-browser support
export const scrollToTop = () => {
  if (typeof window.scroll === 'function') {
    window.scroll(0, 0);
  } else if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, 0);
  }
};

export const openNewTab = path => {
  window.open(path, 'noopener');
};
export const forceRedirectOutsideReact = path => {
  window.location = path;
};

export const reloadPage = () => {
  window.location.reload();
};

export const shouldShowError = ({ error, pristine, touched, active }, force) => {
  if (!error) return false;
  if (force) return true;
  return (touched || !pristine) && !active;
};

// we see a very small number of errors from old/unsupported browsers
// the official polyfills break our tests so we use these pass-through noops
export const matchMedia =
  (typeof window !== 'undefined' && window.matchMedia) || (() => ({ addListener: () => {}, removeListener: () => {} }));
export const requestAnimationFrame = (typeof window !== 'undefined' && window.requestAnimationFrame) || (() => {});
export const cancelAnimationFrame = (typeof window !== 'undefined' && window.cancelAnimationFrame) || (() => {});

export const copyToClipboard = (text, onSuccess = () => {}, onError = () => {}) => {
  // most browsers
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(
      () => onSuccess(),
      err => onError(err)
    );
    return;
  }

  // fallback
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.opacity = '0';
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';

  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
    onSuccess();
  } catch (err) {
    onError(err);
  }

  document.body.removeChild(textArea);
};
